import React, { useContext, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { pricePointTableParser } from 'parser/pricePointParser';
import { getDefaultTableData } from 'gqlQueries/pricePoint';
const errorMessage: string = 'Something went wrong!';

function useFetchTableData() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [count, setCount] = useState(0);
    const variablesRef = useRef<any>({});
    const rawDataRef = useRef<any[]>([]);
    const { appConfig } = useContext(UserContext);
    const pricePointConfig = getConfig('pricePoint', appConfig);

    const [fetchPricePoint, { data: pricePointData, loading: pricePointDataLoading, error: pricePointDataError }] =
        useLazyQuery(getDefaultTableData, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            if (error) return;
            const { getDefaultTableData } = payload;
            if (getDefaultTableData) {
                const parsedTableData = pricePointTableParser(getDefaultTableData, pricePointConfig, appConfig);
                setData({ tableData: parsedTableData });
            }
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        clearData: () => {
            setError(null);
            setData(null);
        },
        throwError: (error: any) => {
            onFetchError(error);
        },
        fetchPricePointTable: (variables: any) => {
            variablesRef.current = variables.variables;
            //only set data to null if function is being called outside/without infinite scroll
            //if offset is equal to default offset, it means request is coming without infinite scroll
            // if (commonConfig.offset === variables.variables?.offset) {
            //     setData(null);
            //     rawDataRef.current = [];
            //     setError(null);
            // }

            setLoading(true);
            setData(null);
            setError(null);
            fetchPricePoint(variables);
            //onFetchComplete(variables);
        },
    };
}

export { useFetchTableData };
